import React, { useState, useContext } from 'react';
import acm from '../AddCarModal.module.css'
import Vin from "../../../../../assets/Icon/Vin";
import Auction from "../../../../../assets/Icon/Auction";
import Select from "react-select"; 
import { selectStyle } from './selectStyle';
import MultiSelect from '../../../../UI/Inputs/MultiSelect';
import { AppContext } from "../../../../../providers/appProvider";
import DateSelect from '../../../../UI/Inputs/DateSelect';
import Form from '../../../../../assets/Style/Form.module.css'
import { useUpdateEffect } from '../../../../../hooks/useUpdateEffect';
import { DEPOSIT_WEBSITE_ID , INSPECTION_WEBSITE_ID} from '../../../../../utils/constans'; 
import { baseFileURL } from '../../../../../Api';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const AddCarForm = ({ newCar, setNewCar, validates, isAdd }) => { 
  const { t } = useTranslation();
  const {appState, app} = useContext(AppContext);
  const [isFetchingLot, setIsFetchingLot] = useState(false);

  const years = [];
  const startYear = 1920;
  const currentYear = new Date().getFullYear();
  
  const websites = appState.websites.map((website) => ({ value: website.id, label: website.name })); 

  const depositWebsite = appState.websites.find(obj => {
    return obj.name === 'DEPOSIT';
  });

  
  var insurances = [
    { value: 1, label: t('MustBeInsured') },
    { value: 2, label: t('Insured') },
    { value: 3, label: t('NotInsured') },
  ];
  
  var sources = [
    { value: 4, label: t('Bitrix') },
    { value: 2, label:  t('CalledCity') },
    { value: 1, label: t('AutovinSite')},
    { value: 3, label: t('CameToOffice') },
    { value: 7, label: t('OldClient') },
    { value: 5, label: t('Recommendation') },
    { value: 6, label: t('OutdoorAd') },
    { value: 8, label:  t('Unknown') },
    { value: 9, label:  t("myautoWebsite") },
    { value: 10, label:  t("autopapaWebsite") },
  ];

  var services = [
    { value: 1, label: t('PurchaseTransportation') },
    { value: 2, label: t('Transportation') },
    { value: 3, label: t('Purchase') },
    { value: 4, label: t('Deposit') },
    { value: 5, label: t('Inspection') }, 
  ];


  if (isAdd ) {
      insurances = [
          { value: 1, label: t('MustBeInsured') },
          // { value: 2, label: t('Insured') },
          { value: 3, label: t('NotInsured') },
      ];
  }  


  for (let year = currentYear; year >= startYear; year--) {
    years.push({ value: year.toString(), label: year.toString() });
  }

  const setModel = async ( makerId, modelId) => {
    setNewCar(prevState => ({
      ...prevState,
      maker_id: makerId ? makerId : 0,
      model_id: modelId ? modelId : 0, 
    }))
  }


  // useUpdateEffect(() => {
  //   var newInsuranceSalerPrice = Math.ceil(newCar.saler_price_car * 0.005);

  //   if (newInsuranceClientPrice < 50 && newCar.website_id != DEPOSIT_WEBSITE_ID ) {
  //       newInsuranceClientPrice= 50;
  //   }

  //   if (newInsuranceSalerPrice < 50 && newCar.website_id != DEPOSIT_WEBSITE_ID) {
  //     newInsuranceSalerPrice = 50;
  //   } 
 
  //   if (newCar.insurance === 3 ) {
  //     setNewCar(prevState => ({
  //       ...prevState,
  //       client_price_insurance: 0,
  //       saler_price_insurance: 0, 
  //     })) 
  //   } else {
  //     setNewCar(prevState => ({
  //       ...prevState,
  //       client_price_insurance: newInsuranceClientPrice,
  //     //  saler_price_insurance: newInsuranceSalerPrice, 
  //     })) 
  //   }

  //  }, [newCar.client_price_car, newCar.saler_price_car, newCar.insurance]);  
 
  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9]+$/; 

    if (!regex.test(keyValue)) {
      event.preventDefault();
    }
  };

  const stylesError = { 
      control: (provided, state) => ({
          ...provided,
          border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
          boxShadow: state.isFocused ? 'none' : 'none',
          '&:hover': {
              border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',  
          },
          minHeight: "35px",
          width: '100%',
          cursor: 'pointer',
          borderRadius: '5px',
      }),
  
  };

  const handleFocus = (e) => {
    if (e.target.value === '0') {
        setNewCar({
            ...newCar,
            [e.target.name]:  ''
          });
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === '') {
      let val = convertToInt(0);
        setNewCar({
          ...newCar,
          [e.target.name]:  val
        });
    };  
  };

  

  function convertToInt(str) {
    const num = parseInt(str, 10);
    return isNaN(num) ? 0 : num;
  }

  const handleChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      [event.target.name]:  val
    });
  };

  const handleInsuranceChange = (selectedOption) => {
    setNewCar((prevCar) => {
        return {
            ...prevCar,
            insurance: selectedOption ? selectedOption.value : 0,
        };
    });
  };
  
  const handleWebsiteChange = (selectedOption) => {
    let updatedWebsiteId = selectedOption ? selectedOption.value : 0;
    let updatedCarPriceInternal = newCar.client_price_internal;
    let clientTransferFee = 0  

    if (newCar.service !== 3) {
      if (newCar.website_id === 16 && updatedWebsiteId !== 16) {
          updatedCarPriceInternal = 0;
      } else if (updatedWebsiteId === 16) {
          if (newCar.client_price_internal < 300) {
              updatedCarPriceInternal = 350;
          } else {
              updatedCarPriceInternal = Math.max(300, newCar.client_price_internal);
          }
      }
    }


    if (newCar.dealer_id > 0 && (selectedOption.label === 'COPART.COM' || selectedOption.label === 'MANHEIM.COM' || selectedOption.label === 'IAAI.COM' || selectedOption.label === 'PIPELINE')) {
          clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(newCar.client_price_car * 0.0015), 15 ) ;
    } else {
          clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(newCar.client_price_car * 0.0015), 60) ;
    }

    let carServiceId = newCar.service;

    if( updatedWebsiteId === DEPOSIT_WEBSITE_ID ) {
        carServiceId = 4; 
    }

    if( updatedWebsiteId === INSPECTION_WEBSITE_ID ) {
        carServiceId = 5;
    }


    setNewCar((prevState) => ({
        ...prevState,
        website_id: updatedWebsiteId,
        service: carServiceId,
        client_price_transfer_fee: clientTransferFee,
        saler_price_transfer_fee: clientTransferFee,
        client_price_internal: updatedCarPriceInternal,
        saler_price_internal: updatedCarPriceInternal
    }));
  }
  
  const handleServiceChange = (selectedOption) => {
    
    let updatedService = selectedOption ? selectedOption.value : 0;
    let updatedCarPriceInternal = newCar.client_price_internal;

    if ( updatedService === 3) {
        updatedCarPriceInternal = 0;
    } else {
      if (newCar.website_id === 16) {
          updatedCarPriceInternal = 0;
      } else if (newCar.website_id === 16) {
          if (newCar.client_price_internal < 300) {
              updatedCarPriceInternal = 350;
          } else {
              updatedCarPriceInternal = Math.max(300, newCar.client_price_internal);
          }
      }

    }

    setNewCar((prevState) => ({
        ...prevState,
        service: updatedService,
        client_price_internal: updatedCarPriceInternal,
        saler_price_internal: updatedCarPriceInternal,
        client_price_transfer_fee: 0,
        saler_price_transfer_fee: 0, 

    }));
  }
  
 
  const handleDateChange = (date) => {
    setNewCar(prevState => ({
        ...prevState,
        purchased_at: date ? date : "",
    }));
};

  const handleLotNumberChange = async (e) => {
    const lot = e.target.value.replace(/[^A-Za-z0-9\s/-]/g, '').toUpperCase();
    
    setNewCar(prevState => ({
      ...prevState,
      lot: lot,
    }));

    // Only search for COPART and IAAI
    const currentWebsite = websites.find(w => w.value === newCar.website_id);
    if (!currentWebsite || (currentWebsite.label !== "COPART.COM" && currentWebsite.label !== "IAAI.COM")) {
      return;
    }

    const lotNumber = lot.replace(/\D/g, "");
    if (lotNumber.trim().length <= 5) return;

    setIsFetchingLot(true);
    try {
      const response = await axios.get(`https://carflow.ge/api2/searchByLot`, {
        params: {
          lot: lotNumber,
          website_id: newCar.website_id,
        },
      });
      const yardName = response.data?.locationDetails?.yardName;
      if (yardName) {
        // Extract state and city name from yard name
        const stateName = yardName.includes(" - ") 
          ? yardName.split(" - ")[0] 
          : "";
        const cityName = yardName.includes(" - ") 
          ? yardName.split(" - ")[1] 
          : yardName;
        
        // Try multiple naming patterns to find a matching city with prices
        const possibleCityNames = [
          cityName.trim(),                                    // "SAN DIEGO"
          `${stateName.trim()} - ${cityName.trim()}`,         // "CA - SAN DIEGO" 
          `${cityName.trim()} (${stateName.trim()})`,         // "SAN DIEGO (CA)"
          `${yardName.trim()}`                                // "CA - SAN DIEGO" (original)
        ];
        
        let matchingCity = null;
        
        // Find the first city that matches a pattern AND has prices for the current website
        for (const namePattern of possibleCityNames) {
          const candidateCity = appState.cities.find(
            (city) => city.name.trim() === namePattern
          );
          
          if (candidateCity) {
            // Check if this city has prices for the current website
            const hasPrice = appState.calculator_prices.some(
              (price) =>
                price.location_city.id === candidateCity.id &&
                price.website.id === newCar.website_id
            );
            
            if (hasPrice) {
              matchingCity = candidateCity;
              break;
            } else if (!matchingCity) {
              // Keep first matching city as fallback
              matchingCity = candidateCity;
            }
          }
        }

        if (matchingCity) {
          const matchingPrice = appState.calculator_prices.find(
            (price) =>
              price.location_city.id === matchingCity.id &&
              price.website.id === newCar.website_id
          );

          if (matchingPrice) {
            console.log("Lot search - Setting receiver to default (1, 1):", {
              transport_price_id: matchingPrice.id,
              location_city: matchingPrice.location_city?.name
            });
            
            setNewCar((prevState) => ({
              ...prevState,
              reciever_country_id: 1,
              reciever_city_id: 1,
              transport_price_id: matchingPrice.id,
            }));
          } else {
            app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
          }
        } else {
          app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
        }
      } else {
        app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
      }
    } catch (error) {
      app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
    } finally {
      setIsFetchingLot(false);
    }
  };

  
  return (
    <div>
 
      <fieldset className={acm.formField}>
        <legend>{t('Automobile')}</legend>
        <div className={acm.inp2colCar}>
          <MultiSelect
            parentOptions={appState.makers}
            childOptions={appState.models}
            parentId={newCar.maker_id}
            childId={newCar.model_id}
            styles={selectStyle}
            onChange={setModel}
            join={"maker_id"}
            placeholder={t('Manufacturer')}
            placeholderSub={t('Model')}
            validate={validates && validates.maker_id ? true : false} 
            validateSub={validates && validates.model_id ? true : false} 
          />
              
        </div>
        <div className={acm.inp2colCar}>

          <div style={{ width: "33%" }}>
            <Select 
              styles={validates && validates.prod_year ? { ...selectStyle, ...stylesError } : selectStyle}
              options={years}
              placeholder={t('Year')}
              value={years.find(option => option.value === newCar.prod_year.toString())}
              onChange={(selectedOption) => {
                setNewCar(prevState => ({
                  ...prevState,
                  prod_year: selectedOption ? Number(selectedOption.value) : 0,
                }));
               
              }}
              isClearable
            />


          </div>

          <div style={{ width: "77%" }}>
            <div className={acm.groupInput} style={{ marginBottom: "0" }}>
              <div className={acm.groupInputIcon}>
                <input
                  type="textS" 
                   className={validates && validates.vin ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                  placeholder="VIN"
                  value={newCar.vin || ''}
                  onChange={(event) => {
                    setNewCar(prevState => ({
                      ...prevState,
                      vin: event.target.value,
                    }));
                  }}

                  onInput={(e) => {
                    if (e.target.value.length > 11) { 
                      e.target.value = e.target.value.substring(0, 17);
                    }
                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                 }}
                  autoComplete="nope"
                />
 
                <div className={acm.crmIcon}>
                  <Vin />
                </div>
              </div>

              {validates && validates.vin &&
                  <div className={ acm.errorMsg } >{validates.vin.message}</div>}

            </div>
          </div>

        </div>

        <div className={acm.inp2colCar} >
          <div style={{ width: "50%" }}>
          <Select
              styles={validates && validates.website_id ? { ...selectStyle, ...stylesError } : selectStyle}
              options={websites}
              value={websites.find(option => option.value === newCar.website_id)}
              onChange={handleWebsiteChange}
               

              placeholder={t('WebSite')}
          />
          </div>
          <div style={{ width: "50%" }}>

            <div className={acm.groupInput} style={{ marginBottom: "0" }}>
              <div className={acm.groupInputIcon}>
                <input
                  type="textS"
                  className={validates && validates.lot ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                   placeholder="Ic/Lot/Stok"
                  value={newCar.lot || ''}
                  onChange={handleLotNumberChange}
                  autoComplete="nope"
                />

                <div className={acm.crmIcon}>
                  {isFetchingLot ? <span>...</span> : <Auction />}
                </div>
              </div>
            </div>


          </div>
        </div>

  
        {app.hasPermission("PURCHASED_AT_SHOW") && 
        <div className={acm.inp2colCar} >
              <div style={{ width: "40%" }}>

                  <div className={acm.comTitle}>
                      {t('PurchaseDate')}
                  </div>
              </div>
              <div style={{ width: "60%" }}> 
                  <div style={{ position: "relative" }}> 
                      <DateSelect
                          defDate={newCar.purchased_at}
                          onChange={handleDateChange}
                          placeholderText={t('Date')}
                          popperClassName={acm.dataContainer}
                          wrapperClassName={acm.dataContainer}
                          dataContainer={acm.dataContainer }
                          isDisabled={!app.hasPermission("PURCHASED_AT_EDIT")}
                          className={validates && validates.purchased_at ? acm.input+' '+ acm.errorInput : acm.input }
                      /> 
                  </div>
              </div>
          </div>
       }



      <div className={acm.inp2colCar}>
            <div style={{ width: "40%" }}>
                <div className={acm.comTitle}>
                    {t('Insurance')}
                </div>
            </div>
            <div style={{ width: "60%" }}>
              <Select
                    styles={validates && validates.insurance ? { ...selectStyle, ...stylesError } : selectStyle}
                    options={insurances}
                    placeholder={t('Insurance')}
                    value={insurances.find(option => option.value === newCar.insurance)}
                    onChange={handleInsuranceChange}
                    isClearable={true}
                    isDisabled={(newCar.client_price_car) >= 20000 || newCar.fund_accept}
              />
              
            </div>
        </div>

      <div className={acm.inp2colCar}>
            <div style={{ width: "40%" }}>
                <div className={acm.comTitle}>
                    {t('Source')}
                </div>
            </div>
            <div style={{ width: "60%" }}>
                <Select
                    styles={validates && validates.source_id ? { ...selectStyle, ...stylesError } : selectStyle}
                    options={sources}
                    placeholder={t('Source')}
                    value={sources.find(option => option.value === newCar.source_id)}
                    onChange={(selectedOption) => {
                        setNewCar(prevState => ({
                            ...prevState,
                            source_id: selectedOption ? selectedOption.value : 0,
                        }));
                    }}
                    isClearable={true}
                />
            </div>
        </div>


        <div className={acm.inp2colCar}>
            <div style={{ width: "40%" }}>
                <div className={acm.comTitle}>
                    {t('Service')}
                </div>
            </div>
            <div style={{ width: "60%" }}>
                <Select
                    styles={validates && validates.service ? { ...selectStyle, ...stylesError } : selectStyle}
                    options={services}
                    placeholder="Service"
                    value={services.find(option => option.value === newCar.service)} 
                    /*
                    onChange={(selectedOption) => {
                        setNewCar(prevState => ({
                            ...prevState,
                            service: selectedOption ? selectedOption.value : 0,
                            client_price_transfer_fee: 0,
                            saler_price_transfer_fee: 0, 
                        }));
                    }}
                    */
                    onChange={handleServiceChange}
                    isDisabled={
                                  (
                                    newCar.website_id === DEPOSIT_WEBSITE_ID ||
                                    newCar.website_id === INSPECTION_WEBSITE_ID
                                  ) && !app.hasPermission("INSPECTION_DEPOSIT_EDIT")
                                }
                    isClearable={true}
                />
            </div>
        </div>

  

          { (( depositWebsite &&  depositWebsite.id === newCar.website_id )  ||  (newCar.client_deposit > 0 )) &&
          <div className={ acm.groupPrice } style={{ marginBottom: "15px" }} >
              <label className={ acm.leftLabel }>{t('ClientDeposit')}</label>
              <div className={ acm.rightInput }>
                  <div className={ Form.priceInput }> 
                      <div className={ Form.priceCurrency }> 
                          USD
                      </div>
                      <input type="text" onFocus={handleFocus}  onBlur={handleBlur}  onKeyPress={handleKeyPress} className={ Form.input }  name="client_deposit" onChange={handleChange}  value={newCar.client_deposit} min="0"/>
                      <div className={ Form.hundred } >.00</div>
                  </div>
              </div>
          </div>
         }

      </fieldset>

    </div>
  );
};

export default AddCarForm;